import { render, staticRenderFns } from "./UserMugs.vue?vue&type=template&id=4b1941a3&"
import script from "./UserMugs.vue?vue&type=script&lang=js&"
export * from "./UserMugs.vue?vue&type=script&lang=js&"
import style0 from "./UserMugs.vue?vue&type=style&index=0&id=4b1941a3&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports